import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import { usersAPI } from '../services/api';

// Pantalla de cambio de contrasena. Sirve para dos cosas:
//   - obligatoria: la contrasena viene de un alta o de un reseteo del admin y
//     la persona no puede usar nada hasta cambiarla. No hay boton de salida
//     mas que cerrar sesion.
//   - voluntaria: cualquiera puede entrar aqui a cambiarla cuando quiera.
export default function ChangePasswordPage() {
  const { user, aplicarPassword, logout } = useAuth();
  const nav = useNavigate();
  const obligatorio = user && user.must_change_password === true;

  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirma, setConfirma] = useState('');
  const [enviando, setEnviando] = useState(false);

  // Se valida aqui tambien, no solo en el servidor, para que el error salga
  // antes de gastar una vuelta. El servidor manda igual.
  const problema = () => {
    if (!actual) return 'Escriba su contrasena actual';
    if (nueva.length < 10) return 'La contrasena nueva debe tener al menos 10 caracteres';
    if (nueva === actual) return 'La contrasena nueva no puede ser igual a la actual';
    if (nueva !== confirma) return 'Las dos contrasenas no coinciden';
    return null;
  };

  const enviar = async (e) => {
    e.preventDefault();
    const p = problema();
    if (p) { toast.error(p); return; }
    setEnviando(true);
    try {
      const { data } = await usersAPI.changePassword(user.id, {
        current_password: actual,
        new_password: nueva,
      });
      aplicarPassword(data);
      toast.success('Contrasena actualizada');
      nav('/quotes', { replace: true });
    } catch (err) {
      const msg = (err.response && err.response.data && err.response.data.error)
        || 'No se pudo cambiar la contrasena';
      toast.error(msg);
    } finally {
      setEnviando(false);
    }
  };

  const campo = {
    width: '100%', padding: '9px 11px', fontSize: 14, borderRadius: 6,
    background: 'var(--bg)', color: 'var(--text)',
    border: '1px solid var(--border)', marginTop: 5,
  };
  const etiqueta = { fontSize: 12, color: 'var(--text-2)' };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: 20, background: 'var(--bg)',
    }}>
      <div style={{
        width: 400, maxWidth: '100%', padding: 28, borderRadius: 10,
        background: 'var(--bg-2)', border: '1px solid var(--border)',
      }}>
        <h2 style={{ margin: 0, fontSize: 19, color: 'var(--text)' }}>
          {obligatorio ? 'Cambie su contrasena' : 'Cambiar contrasena'}
        </h2>

        {obligatorio && (
          <p style={{ fontSize: 13, lineHeight: 1.5, color: 'var(--text-2)', marginTop: 10 }}>
            La contrasena con la que acaba de entrar es temporal y solo sirve una
            vez. Elija una propia para continuar.
          </p>
        )}

        <form onSubmit={enviar} style={{ marginTop: 18 }}>
          <label style={etiqueta}>
            Contrasena actual
            <input type="password" style={campo} value={actual} autoFocus
                   autoComplete="current-password"
                   onChange={e => setActual(e.target.value)} />
          </label>

          <label style={{ ...etiqueta, display: 'block', marginTop: 14 }}>
            Contrasena nueva
            <input type="password" style={campo} value={nueva}
                   autoComplete="new-password"
                   onChange={e => setNueva(e.target.value)} />
          </label>

          <label style={{ ...etiqueta, display: 'block', marginTop: 14 }}>
            Confirme la contrasena nueva
            <input type="password" style={campo} value={confirma}
                   autoComplete="new-password"
                   onChange={e => setConfirma(e.target.value)} />
          </label>

          <p style={{ fontSize: 11.5, color: 'var(--text-2)', marginTop: 12, lineHeight: 1.5 }}>
            Minimo 10 caracteres. No la reutilice de otro sistema.
          </p>

          <button type="submit" className="btn btn-primary" disabled={enviando}
                  style={{ width: '100%', marginTop: 8, padding: '10px 0' }}>
            {enviando ? 'Guardando...' : 'Guardar contrasena'}
          </button>
        </form>

        <button onClick={logout}
                style={{
                  width: '100%', marginTop: 14, padding: 8, fontSize: 12.5,
                  background: 'none', border: 'none', cursor: 'pointer',
                  color: 'var(--text-2)', textDecoration: 'underline',
                }}>
          {obligatorio ? 'Salir' : 'Volver a entrar despues'}
        </button>
      </div>
    </div>
  );
}
